import { render, staticRenderFns } from "./BitQTour.vue?vue&type=template&id=2076fbc2&scoped=true"
import script from "./BitQTour.vue?vue&type=script&lang=js"
export * from "./BitQTour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2076fbc2",
  null
  
)

export default component.exports